export default __webpack_public_path__ + "media/images/this-works-logo-23534925.svg";